const widthBlockEditor = 5;
export default widthBlockEditor;